module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Select', {
    ref: "timeZone",
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "placeholder": _vm.placeNum,
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading,
      "transfer": ""
    },
    on: {
      "on-change": _vm.onChange
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('Option', {
      key: item.num,
      attrs: {
        "value": item.num
      }
    }, [_vm._v("\n          " + _vm._s(item.name.word + '----------------时差：' + item.num) + "\n  ")])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5bf5434","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TimeZoneSelect.vue
// module id = 1925
// module chunks = 8